import { DataType } from "shared/types";

import OverflowingColumnCell from "features/ui/MaterialTable/components/OverflowingColumnCell";

import HeaderText from "./HeaderText";
import {
  ColumnCellRenderProps,
  ColumnHeaderRenderProps,
  SmartGroupColumnDefinition,
  SmartGroupColumnId,
} from "./types";

export const projectIDColumn: SmartGroupColumnDefinition = {
  id: SmartGroupColumnId.PROJECT_ID,

  getSchema: () => ({
    accessor: "groupExternalID",
    label: "",
    dataType: DataType.STRING,
    columnWidth: 100,
  }),

  renderHeader: ({ context }: ColumnHeaderRenderProps) => (
    <HeaderText text={context.t("schema:project_id")} />
  ),

  renderCell: ({ row, context }: ColumnCellRenderProps) => (
    <OverflowingColumnCell
      value={row.groupExternalID || context.t("common:not_available")}
    />
  ),
};
